module.exports = __webpack_public_path__ + "static/media/hero.5c290c4d.jpg";